import { apolloClient } from '../../utils/apollo';

const state = {
    id: null,
    name: null,
    color: null,
    locale: null,
    departments: []
};

const mutations = {
    SET_SETTINGS(state, settings) {
        Object.assign(state, settings);
    }
};

const actions = {
    async getSettings({ commit }) {
        await apolloClient
            .query({
                query: require("@/graphql/queries/institution").default
            })
            .then(response => {
                commit('SET_SETTINGS', response.data.institution);
            })
            .catch(error => {
                console.log('Error getting settings', error);
            });
    }
};

const getters = {
    id: state => state.id,
    name: state => state.name,
    color: state => state.color,
    locale: state => state.locale,
    departments: state => state.departments
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};